import React, { Component } from "react";
import { ProgressBar } from "react-bootstrap";

class Project extends Component {
  render() {
    const {
      goalIcon,
      goaltitle,
      title,
      orgName,
      coverImage,
      videoThumbnail,
      location,
      totalEndorsementAmount,
      budgetRequired
    } = this.props.project;

    const ListView = this.props.listview;

    const now = (totalEndorsementAmount / parseInt(budgetRequired)).toFixed(2);

    return (
      <React.Fragment>
        {ListView ? (
          <div className="overlay">
            <div
              className="project-bg"
              style={
                coverImage !== null
                  ? {
                      backgroundImage:
                        "url(" +
                        process.env.REACT_APP_ASSETS_URL +
                        coverImage +
                        ")"
                    }
                  : {
                      backgroundImage: "url(" + videoThumbnail + ")"
                    }
              }
            />
            <div className="row project-content">
              <div className="col-lg-8 info-col text-white">
                <div
                  className="goal-div"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <img
                    className="goal-icon"
                    src={process.env.REACT_APP_ASSETS_URL + goalIcon}
                    style={{
                      width: "40px",
                      height: "40px",
                      marginRight: "10px"
                    }}
                    alt="goal icon"
                  />
                  <span className="goal-title">{goaltitle}</span>
                </div>
                <h1 className="project-title" style={{ textAlign: "left" }}>
                  {title}
                </h1>
                <span className="by-org" style={{ display: "flex" }}>
                  by {orgName}
                </span>
                <span className="location mt-2 text-left">
                  <i className="fas fa-map-marker-alt" /> {location}
                </span>
                <ProgressBar
                  className="mt-2 mb-2"
                  active
                  now={now}
                  label={`${now}%`}
                />
              </div>
              <div
                className="col-lg-4 project-button-col"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <button className="project-button" type="button">
                  Endorse Project
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="overlay-thumb">
            <div
              className="project-bg"
              style={
                coverImage !== null
                  ? {
                      backgroundImage:
                        "url(" +
                        process.env.REACT_APP_ASSETS_URL +
                        coverImage +
                        ")"
                    }
                  : {
                      backgroundImage: "url(" + videoThumbnail + ")"
                    }
              }
            />
            <div className="col project-content-thumb text-white">
              <div
                className="mb-2 goaldiv"
                style={{ display: "flex", alignItems: "center" }}
              >
                <img
                  className="goalicon"
                  src={process.env.REACT_APP_ASSETS_URL + goalIcon}
                  style={{ width: "40px", height: "40px", marginRight: "10px" }}
                  alt="goal icon"
                />
                <span className="goal-title">{goaltitle}</span>
              </div>
              <h1 className="project-title" style={{ textAlign: "left" }}>
                {title}
              </h1>
              <span style={{ display: "flex" }}>by {orgName}</span>
              <span className="location my-2 text-left">
                <i class="fas fa-map-marker-alt" /> {location}
              </span>
              <ProgressBar
                className="mb-2"
                active
                now={now}
                label={`${now}%`}
              />
              <button className="project-button mt-2" type="button">
                Endorse Project
              </button>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default Project;



// WEBPACK FOOTER //
// ./src/Components/Projects/Project.js